// Modules
import React from 'react'

// Assets
import styles from './styles.module.css'
import { Button } from '../../components'

const venueUrl = 'https://rose1.by/catalog/tsvetochnaya-podpiska/1878/'

const Gifts = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.flowerIcon}>🌸</div>
        <h2 className={styles.mainTitle}>Цветочная подписка</h2>
        <div className={styles.divider}></div>
      </div>

      <div className={styles.content}>
        <p className={styles.description}>
          Нам будет очень приятно, если вместо традиционных живых цветов 
          вы пополните баланс нашей цветочной подписки. 
          Так свежие цветы будут напоминать нам о вашей любви и поддержке 
          еще долгое время после праздника.
        </p>

        {/* <div className={styles.detailsCard}>
          <h3 className={styles.detailTitle}>Данные для подписки</h3>
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>Наименование:</span>
            <span>Цветочная подписка свадебная</span>
          </div>
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>Получатель:</span>
            <span>Немиров Александр Николаевич</span>
          </div>
        </div> */}

        <Button 
          text="Пополнить подписку" 
          onClick={() => window.open(venueUrl)}
          className={styles.donateButton}
        />

        <p className={styles.note}>
          Спасибо, что делаете наш праздник ещё прекраснее!
        </p>
      </div>
    </div>
  )
}

export default Gifts